export default "__VITE_ASSET__BLkJm5Jy__"